import api from '../../utils/api'

import { useState } from 'react'



/* Hooks */
import useFlashMessage from '../../hooks/useFlashMessage'

/* form */
import FormColorType from './Form/FormColorType'

function NewColorType({ btCancelAction, handleOnSuccess }) {
    const [token] = useState(localStorage.getItem('token') || '')
    const { setFlashMessage } = useFlashMessage()



    async function registerColorType(colorType) {
        let msgType = 'success'

        const data = await api.post('/colorType/new', colorType, {
            headers: {
                Authorization: `Bearer ${JSON.parse(token)}`,
            },

        }).then((response) => {
            return response.data
        })
            .catch((err) => {
                msgType = 'error'
                return err.response.data
            })

        setFlashMessage(data.message, msgType)

        if (msgType !== 'error') {

            handleOnSuccess()
        }
    }

    return (
        <FormColorType title="Cadastrar Tipo de Cor" handleSubmit={registerColorType} btCancelAction={btCancelAction} btnText="Cadastrar" />
    )
}

export default NewColorType
